import { CSSProperties } from "react";

import { cn } from "@/lib/utils";

interface LoadingSpinnerProps {
	size?: string;
	className?: string;
	style?: CSSProperties;
	/**
	 * Useful when you are fading out the loading spinner, and you want to keep the spinner in place. Then disabling spinning
	 * can improve performance.
	 */
	disableSpinning?: boolean;
}

export function LoadingSpinner({ size = "1.2rem", className, style, disableSpinning }: LoadingSpinnerProps) {
	return (
		<svg
			className={cn(!disableSpinning && "animate-spin", className)}
			style={{
				width: size,
				height: size,
				...style,
			}}
			xmlns="http://www.w3.org/2000/svg"
			fill="none"
			viewBox="0 0 24 24"
		>
			<circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" />
			<path
				className="opacity-75"
				fill="currentColor"
				d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
			/>
		</svg>
	);
}
